import React from 'react'
import Dashboard from '../../Screens/Auditor/Dashboard'
import ViewAllSales from '../../Screens/Auditor/ViewAllSales'
import VoidedSales from '../../Screens/Auditor/VoidedSales'
import Refunds from '../../Screens/Auditor/Refunds'
import TillAudit from '../../Screens/Auditor/TillAudit'
import StockAuditReport from '../../Screens/Auditor/StockAuditReport'
import AdjustmentAudit from '../../Screens/Auditor/AdjustmentAudit'
import PriceChangeAudit from '../../Screens/Auditor/PriceChangeAudit'
import TransactionsReview from '../../Screens/Auditor/TransactionsReview'
import ProductCatalog from '../../Screens/Auditor/ProductCatalog'
import StockMovementHistory from '../../Screens/Auditor/StockMovementHistory'
import StockMovementHistoryDetails from '../../Screens/Auditor/StockMovementHistoryDetails'
import WarehouseStockLevels from '../../Screens/Auditor/WarehouseStockLevels'
import BranchStockLevels from '../../Screens/Auditor/BranchStockLevels'
import StockTransfersAudit from '../../Screens/Auditor/StockTransfersAudit'
import SupplierReceivingAudit from '../../Screens/Auditor/SupplierReceivingAudit'
import ActivityLog from '../../Screens/Auditor/ActivityLog'
import LoginLog from '../../Screens/Auditor/LoginLog'
import PermissionChanges from '../../Screens/Auditor/PermissionChanges'
import Reports from '../../Screens/Auditor/Reports'
import Profile from '../../Screens/Auditor/Profile'

const Main = ({ activeScreen, screenParams }) => {
  const renderScreen = () => {
    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard />
      case 'view-all-sales':
        return <ViewAllSales />
      case 'voided-sales':
        return <VoidedSales />
      case 'refunds':
        return <Refunds />
      case 'till-audit':
        return <TillAudit />
      case 'stock-audit-report':
        return <StockAuditReport />
      case 'adjustment-audit':
        return <AdjustmentAudit />
      case 'price-change-audit':
        return <PriceChangeAudit />
      case 'transactions-review':
        return <TransactionsReview />
      case 'product-catalog':
        return <ProductCatalog />
      case 'stock-movement-history':
        return <StockMovementHistory />
      case 'stock-movement-history-detail':
        return <StockMovementHistoryDetails movement={screenParams?.movement} />
      case 'warehouse-stock-levels':
        return <WarehouseStockLevels />
      case 'branch-stock-levels':
        return <BranchStockLevels />
      case 'stock-transfers-audit':
        return <StockTransfersAudit />
      case 'supplier-receiving-audit':
        return <SupplierReceivingAudit />
      case 'activity-log':
        return <ActivityLog />
      case 'login-log':
        return <LoginLog />
      case 'permission-changes':
        return <PermissionChanges />
      case 'reports':
        return <Reports />
      case 'profile':
        return <Profile />
      default:
        return <Dashboard />
    }
  }

  return (
<main id="main" className="main">
      {renderScreen()}
</main>
  )
}

export default Main